module.exports = __webpack_public_path__ + "img/brokerage-concierge.f419e779.png";